/* Hardcoded hotel catalog — listing + detail. Backend can replace later. */

export const FILTER_CARDS = [
  { id: "all", label: "All hotels", icon: "fa-hotel", keywords: [] },
  {
    id: "luxury",
    label: "Luxury stays",
    icon: "fa-gem",
    keywords: ["luxury", "5-star", "premium"],
  },
  {
    id: "business",
    label: "Business hotels",
    icon: "fa-briefcase",
    keywords: ["business", "corporate", "conference"],
  },
  {
    id: "resort",
    label: "Resorts",
    icon: "fa-umbrella-beach",
    keywords: ["resort", "pool", "spa", "foothills", "river"],
  },
  {
    id: "boutique",
    label: "Boutique hotels",
    icon: "fa-spa",
    keywords: ["boutique", "design", "heritage"],
  },
  {
    id: "budget",
    label: "Budget stays",
    icon: "fa-wallet",
    keywords: ["budget", "value", "economy"],
  },
  {
    id: "family",
    label: "Family friendly",
    icon: "fa-people-roof",
    keywords: ["family", "kids", "suite"],
  },
];

export const HOTEL_BOOKING_STEPS = [
  { step: 1, label: "Check-in", icon: "fa-solid fa-calendar-check" },
  { step: 2, label: "Check-out", icon: "fa-solid fa-calendar-xmark" },
  { step: 3, label: "Room", icon: "fa-solid fa-bed" },
  { step: 4, label: "Guests", icon: "fa-solid fa-users" },
];

export const HOTEL_CONTENT_NAV = [
  {
    id: "about",
    label: "About",
    icon: "fa-solid fa-circle-info",
    hint: "Description & highlights",
  },
  {
    id: "amenities",
    label: "Amenities",
    icon: "fa-solid fa-wand-magic-sparkles",
    hint: "Facilities on site",
  },
  {
    id: "gallery",
    label: "Photos",
    icon: "fa-solid fa-images",
    hint: "See the hotel",
  },
  {
    id: "reviews",
    label: "Reviews",
    icon: "fa-solid fa-star",
    hint: "Guest experiences",
  },
  {
    id: "location",
    label: "Map",
    icon: "fa-solid fa-map-location-dot",
    hint: "Directions & address",
  },
  {
    id: "nearby",
    label: "Nearby",
    icon: "fa-solid fa-compass",
    hint: "More hotels around you",
  },
];

export const hotelAmenityIcon = (raw) => {
  const n = String(raw || "").toLowerCase();
  if (/wifi|wi-fi|internet/.test(n)) return "fa-solid fa-wifi";
  if (/pool|swim/.test(n)) return "fa-solid fa-water-ladder";
  if (/spa|massage/.test(n)) return "fa-solid fa-spa";
  if (/parking|valet/.test(n)) return "fa-solid fa-square-parking";
  if (/breakfast|dining|restaurant|café|cafe/.test(n))
    return "fa-solid fa-utensils";
  if (/gym|fitness/.test(n)) return "fa-solid fa-dumbbell";
  if (/ac|air condition|cooling/.test(n)) return "fa-solid fa-snowflake";
  if (/room service/.test(n)) return "fa-solid fa-bell-concierge";
  if (/bar|lounge/.test(n)) return "fa-solid fa-martini-glass";
  if (/kids|family|play/.test(n)) return "fa-solid fa-children";
  if (/conference|meeting/.test(n)) return "fa-solid fa-chalkboard-user";
  if (/transfer|airport|shuttle/.test(n)) return "fa-solid fa-van-shuttle";
  if (/beach/.test(n)) return "fa-solid fa-umbrella-beach";
  if (/kitchen/.test(n)) return "fa-solid fa-kitchen-set";
  return "fa-solid fa-circle-check";
};

const IMG = {
  lobby:
    "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=900&q=85&auto=format&fit=crop",
  room:
    "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=900&q=85&auto=format&fit=crop",
  pool:
    "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=900&q=85&auto=format&fit=crop",
  suite:
    "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=900&q=85&auto=format&fit=crop",
  dining:
    "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=900&q=85&auto=format&fit=crop",
  lobby2:
    "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=900&q=85&auto=format&fit=crop",
  spa:
    "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=900&q=85&auto=format&fit=crop",
  bed:
    "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=900&q=85&auto=format&fit=crop",
};

export const HARDCODED_HOTELS = [
  {
    id: 1,
    slug: "hyatt-regency-dehradun",
    name: "Hyatt Regency Dehradun Resort & Spa",
    category: "Luxury",
    address: "Mussoorie Road, Malsi Forest Edge, Dehradun, Uttarakhand",
    lat: 30.3885,
    lng: 78.0752,
    description:
      "Luxury resort at the Shivalik foothills with forest and Mussoorie valley views. Infinity pool, rooftop dining, spa, and grand ballrooms for celebrations — a quiet escape en route to Mussoorie yet minutes from Dehradun.",
    price: 14999,
    image: IMG.pool,
    images: [IMG.pool, IMG.suite, IMG.dining, IMG.spa, IMG.lobby],
    type: "Luxury · Resort · Spa · Premium",
    tags: ["Luxury", "Resort", "Spa"],
    rating: 4.8,
    checkInTime: "3:00 PM",
    checkOutTime: "12:00 PM",
    amenities: [
      { name: "Infinity Pool" },
      { name: "Spa & Wellness" },
      { name: "Rooftop Dining" },
      { name: "Kids Club" },
      { name: "Free Wi-Fi" },
      { name: "Fitness Centre" },
      { name: "Valet Parking" },
      { name: "Room Service" },
    ],
    rooms: [
      { id: "hr-king", name: "King Guest Room", price: 14999, capacity: 2 },
      { id: "hr-suite", name: "Valley View Suite", price: 21999, capacity: 3 },
      { id: "hr-reg", name: "Regency Suite", price: 28999, capacity: 4 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Ananya R.",
        rating: 5,
        message:
          "Stunning hill views and a beautiful pool. Perfect weekend getaway from the city.",
        created_at: "2026-08-12",
      },
      {
        id: 2,
        user_name: "Vikram S.",
        rating: 5,
        message: "Service was excellent and rooms felt brand new. Loved Beyul at night.",
        created_at: "2026-07-28",
      },
    ],
  },
  {
    id: 2,
    slug: "hyatt-centric-rajpur-road",
    name: "Hyatt Centric Rajpur Road Dehradun",
    category: "Business",
    address: "Rajpur Road, Dehradun, Uttarakhand",
    lat: 30.3456,
    lng: 78.0489,
    description:
      "Lifestyle 5-star hotel on Rajpur Road in the heart of Dehradun. Stylish rooms, refined dining, and a prime location for shopping, cafés, and business meetings across the Doon Valley.",
    price: 9999,
    image: IMG.dining,
    images: [IMG.dining, IMG.bed, IMG.lobby, IMG.room, IMG.suite],
    type: "Business · Luxury · Corporate",
    tags: ["Business", "Luxury", "Central"],
    rating: 4.7,
    checkInTime: "2:00 PM",
    checkOutTime: "12:00 PM",
    amenities: [
      { name: "High-speed Wi-Fi" },
      { name: "Restaurant" },
      { name: "Fitness Centre" },
      { name: "Meeting Rooms" },
      { name: "Parking" },
      { name: "Room Service" },
      { name: "Air Conditioning" },
    ],
    rooms: [
      { id: "hc-std", name: "Centric King", price: 9999, capacity: 2 },
      { id: "hc-twin", name: "Centric Twin", price: 10499, capacity: 2 },
      { id: "hc-suite", name: "Corner Suite", price: 14999, capacity: 3 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Neha K.",
        rating: 5,
        message: "Great Rajpur Road location. Clean, modern, and very convenient.",
        created_at: "2026-08-02",
      },
      {
        id: 2,
        user_name: "Rohit M.",
        rating: 4,
        message: "Comfortable stay for a work trip. Breakfast spread was solid.",
        created_at: "2026-06-18",
      },
    ],
  },
  {
    id: 3,
    slug: "taj-mussoorie-foothills",
    name: "Taj Mussoorie Foothills",
    category: "Luxury",
    address: "Mauza Malsi, Near Max Hospital, Dehradun, Uttarakhand",
    lat: 30.392,
    lng: 78.078,
    description:
      "Taj luxury amidst the Himalayan foothills with 115 rooms and suites. Elegant dining, nature trails, and family-friendly experiences — a serene base between Dehradun and Mussoorie.",
    price: 16999,
    image: IMG.lobby2,
    images: [IMG.lobby2, IMG.suite, IMG.spa, IMG.dining, IMG.pool],
    type: "Luxury · 5-star · Premium · Foothills",
    tags: ["Luxury", "Taj", "Foothills"],
    rating: 4.9,
    checkInTime: "2:00 PM",
    checkOutTime: "12:00 PM",
    amenities: [
      { name: "Spa" },
      { name: "Pool" },
      { name: "Fine Dining" },
      { name: "Nature Trails" },
      { name: "Free Wi-Fi" },
      { name: "Valet Parking" },
      { name: "Butler Service" },
      { name: "Fitness Centre" },
    ],
    rooms: [
      { id: "tj-deluxe", name: "Deluxe Room", price: 16999, capacity: 2 },
      { id: "tj-prem", name: "Premium Room", price: 19999, capacity: 2 },
      { id: "tj-suite", name: "Luxury Suite", price: 27999, capacity: 3 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Kabir L.",
        rating: 5,
        message: "True Taj hospitality with peaceful foothill views. Unforgettable.",
        created_at: "2026-08-15",
      },
    ],
  },
  {
    id: 4,
    slug: "shaheen-bagh-dehradun",
    name: "Shaheen Bagh Luxury Resort & Spa",
    category: "Boutique",
    address: "Tons River Side, Dehradun, Uttarakhand",
    lat: 30.278,
    lng: 77.995,
    description:
      "Award-winning boutique riverside resort sprawled over lush orchards beside the Tons River. A celebrity favourite for privacy, spa rituals, picnics by the water, and quiet Himalayan evenings.",
    price: 11999,
    image: IMG.spa,
    images: [IMG.spa, IMG.pool, IMG.suite, IMG.lobby, IMG.dining],
    type: "Boutique · Resort · River · Spa",
    tags: ["Boutique", "Resort", "River"],
    rating: 4.8,
    checkInTime: "2:00 PM",
    checkOutTime: "11:00 AM",
    amenities: [
      { name: "Riverside Setting" },
      { name: "Spa" },
      { name: "Orchard Gardens" },
      { name: "Restaurant" },
      { name: "Free Wi-Fi" },
      { name: "Parking" },
      { name: "Pool" },
    ],
    rooms: [
      { id: "sb-cottage", name: "Garden Cottage", price: 11999, capacity: 2 },
      { id: "sb-river", name: "River View Suite", price: 15999, capacity: 2 },
      { id: "sb-villa", name: "Luxury Villa", price: 21999, capacity: 4 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Meera T.",
        rating: 5,
        message: "So peaceful by the river. Spa and gardens are magical.",
        created_at: "2026-07-09",
      },
    ],
  },
  {
    id: 5,
    slug: "lemon-tree-dehradun",
    name: "Lemon Tree Hotel, Dehradun",
    category: "Business",
    address: "Near Clock Tower / Rajpur Road area, Dehradun, Uttarakhand",
    lat: 30.3255,
    lng: 78.0436,
    description:
      "Bright, contemporary business hotel in central Dehradun. Reliable Wi-Fi, cheerful service, and easy access to Rajpur Road, ISBT, and local markets — ideal for short corporate stays.",
    price: 5499,
    image: IMG.bed,
    images: [IMG.bed, IMG.room, IMG.dining, IMG.lobby],
    type: "Business · Corporate · Value",
    tags: ["Business", "Central", "Wi-Fi"],
    rating: 4.4,
    checkInTime: "2:00 PM",
    checkOutTime: "12:00 PM",
    amenities: [
      { name: "Free Wi-Fi" },
      { name: "Restaurant" },
      { name: "Meeting Rooms" },
      { name: "Parking" },
      { name: "Breakfast" },
      { name: "Air Conditioning" },
    ],
    rooms: [
      { id: "lt-std", name: "Standard Room", price: 5499, capacity: 2 },
      { id: "lt-sup", name: "Superior Room", price: 6499, capacity: 2 },
      { id: "lt-exec", name: "Executive Room", price: 7499, capacity: 3 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Deepak J.",
        rating: 4,
        message: "Handy central location. Clean rooms and friendly staff.",
        created_at: "2026-06-30",
      },
    ],
  },
  {
    id: 6,
    slug: "fairfield-marriott-dehradun",
    name: "Fairfield by Marriott Dehradun",
    category: "Business",
    address: "Dehradun, Uttarakhand",
    lat: 30.334,
    lng: 78.052,
    description:
      "Marriott-branded business hotel with consistent comfort, fitness access, and meeting-ready spaces. A trusted pick for travellers who want familiar standards in the Doon Valley.",
    price: 6999,
    image: IMG.lobby,
    images: [IMG.lobby, IMG.bed, IMG.room, IMG.dining],
    type: "Business · Corporate · Conference",
    tags: ["Business", "Marriott", "Meetings"],
    rating: 4.5,
    checkInTime: "3:00 PM",
    checkOutTime: "12:00 PM",
    amenities: [
      { name: "Free Wi-Fi" },
      { name: "Fitness Centre" },
      { name: "Meeting Rooms" },
      { name: "Restaurant" },
      { name: "Parking" },
      { name: "Breakfast" },
    ],
    rooms: [
      { id: "fm-king", name: "King Guest Room", price: 6999, capacity: 2 },
      { id: "fm-queen", name: "Queen Guest Room", price: 6799, capacity: 2 },
      { id: "fm-suite", name: "Junior Suite", price: 9499, capacity: 3 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Amit P.",
        rating: 4,
        message: "Solid Marriott stay. Quiet rooms and good breakfast.",
        created_at: "2026-08-01",
      },
    ],
  },
  {
    id: 7,
    slug: "tree-of-life-dehradun",
    name: "Tree of Life Resort, Dehradun Foothills",
    category: "Family",
    address: "Dehradun Foothills, Uttarakhand",
    lat: 30.401,
    lng: 78.09,
    description:
      "Boutique foothill resort tailored for families and slow travel. Spacious suites, nature around you, warm hospitality, and easy drives to Mussoorie, Robber’s Cave, and Sahastradhara.",
    price: 8999,
    image: IMG.suite,
    images: [IMG.suite, IMG.pool, IMG.spa, IMG.lobby, IMG.room],
    type: "Family · Resort · Foothills · Boutique",
    tags: ["Family", "Resort", "Kids"],
    rating: 4.6,
    checkInTime: "2:00 PM",
    checkOutTime: "11:00 AM",
    amenities: [
      { name: "Kids Friendly" },
      { name: "Pool" },
      { name: "Spa" },
      { name: "Restaurant" },
      { name: "Free Wi-Fi" },
      { name: "Parking" },
      { name: "Garden Views" },
    ],
    rooms: [
      { id: "tol-cottage", name: "Cottage Room", price: 8999, capacity: 2 },
      { id: "tol-family", name: "Family Suite", price: 11999, capacity: 4 },
      { id: "tol-prem", name: "Premium Suite", price: 13999, capacity: 3 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Sneha & Arjun",
        rating: 5,
        message: "Kids loved the space and gardens. Perfect family foothill stay.",
        created_at: "2026-07-22",
      },
    ],
  },
  {
    id: 8,
    slug: "red-fox-lemon-tree-dehradun",
    name: "Red Fox by Lemon Tree Hotels, Dehradun",
    category: "Budget",
    address: "Dehradun, Uttarakhand",
    lat: 30.318,
    lng: 78.032,
    description:
      "Smart budget-friendly stay from the Lemon Tree group. Clean rooms, essential amenities, and a practical base for exploring Clock Tower, Paltan Bazaar, and day trips around Dehradun.",
    price: 3299,
    image: IMG.room,
    images: [IMG.room, IMG.bed, IMG.lobby, IMG.dining],
    type: "Budget · Value · Economy",
    tags: ["Budget", "Value", "Breakfast"],
    rating: 4.2,
    checkInTime: "2:00 PM",
    checkOutTime: "12:00 PM",
    amenities: [
      { name: "Free Breakfast" },
      { name: "Free Wi-Fi" },
      { name: "24×7 Front Desk" },
      { name: "Air Conditioning" },
      { name: "Parking" },
    ],
    rooms: [
      { id: "rf-std", name: "Standard Room", price: 3299, capacity: 2 },
      { id: "rf-sup", name: "Superior Room", price: 3799, capacity: 2 },
      { id: "rf-twin", name: "Twin Room", price: 3599, capacity: 2 },
    ],
    reviews: [
      {
        id: 1,
        user_name: "Priya D.",
        rating: 4,
        message: "Good value in Dehradun. Clean and no fuss — exactly what we needed.",
        created_at: "2026-08-20",
      },
    ],
  },
];

export const getHotelBySlug = (slug) =>
  HARDCODED_HOTELS.find((h) => h.slug === slug) || null;

export const getNearbyHotels = (slug, limit = 4) =>
  HARDCODED_HOTELS.filter((h) => h.slug !== slug).slice(0, limit);
